import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { VisitStatus } from 'src/models/visit/_types';

interface VisitStatusFilterProps {
  field: string;
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const statusOptions = [
  { id: VisitStatus.Reserved, name: 'Reserved' },
  { id: VisitStatus.Registered, name: 'Registered' },
  { id: VisitStatus.Completed, name: 'Completed' },
  { id: VisitStatus.NoShowed, name: 'No Show' },
  { id: VisitStatus.LateCancelled, name: 'Late Cancellation' },
  { id: VisitStatus.Cancelled, name: 'Cancelled' },
];

export const VisitStatusFilter: React.FC<VisitStatusFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) => statusOptions.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) => statusOptions.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={statusOptions}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? statusOptions.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Status" />
      )}
      isOptionEqualToValue={(option, value) =>
        option.id === (typeof value === 'string' ? value : value.id)
      }
    />
  );
};
